import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { TrainingView as TV } from '../../features/training'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function TrainingView(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <TV id={props.id} />
}
